import React, { useEffect, useState } from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import CurrencyCalculator from '../../eximpe-tools/CurrencyCalculator';
import { useSavings } from '../contexts/SavingsContext';
import { formatCurrency } from '../../../utlis/currency';
import RBI from '../assets/rbi.svg';
import Poweredby from '../assets/poweredby.webp';
import CountUp from 'react-countup';

const FeaturesSection: React.FC = () => {
  const { savedAmount } = useSavings();

  const savedAmountValue = Math.trunc(Number(savedAmount));


  const defaultUTM =
  "?utm_source=online&utm_medium=website&utm_campaign=website_lead&utm_term=landing_page";

const [utmParams, setUtmParams] = useState<string>(() => {
  // Try to get from localStorage on initial load (e.g. second visit)
  return localStorage.getItem('utm_params') || defaultUTM;
});

useEffect(() => {
  const queryString = window.location.search;
  if (queryString && queryString.includes('utm_')) {
    localStorage.setItem('utm_params', queryString);
    setUtmParams(queryString); // Triggers rerender
  }
}, []);

const signupLink = `https://app.eximpe.com/auth/sign-up${utmParams}`;


  const benefits = [
    "Zero FX margin(Live Google Rate)",
    "Instant e-FIRA",
    "Industry first monthly-flat pricing",
    "100% safe and compliant",
    
  ];

  console.log("Saved Amount:", savedAmount);

  return (
    <section id="features" className="py-20 bg-gradient-to-b from-gray-50 to-white lg:px-[13%] mt-[70px] overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          {/* Left side - Text content */}
          <div className="w-full md:w-1/2 mb-12 md:mb-20  ">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-6 leading-tight text-center lg:text-left lg:text-wrap">
  Save Up To{" "}
  {savedAmountValue ? (
    <span className="text-[#1c9e86]">
      <CountUp
        end={savedAmountValue}
        duration={.5}
        formattingFn={(value) => formatCurrency(value, 0)}
      />
    </span>
  ) : (
    <span className="text-[#1c9e86]"></span>
  )}{" "}
  Annually On International Business Payments
</h2>

            <p className="text-2xl text-center lg:text-left text-gray-600 mb-8 leading-relaxed">
            Get Global Bank Accounts in USD, EUR, GBP & CAD.
            </p>

            {/* Benefits list with checkmarks */}
            <div className='flex flex-col items-center lg:items-start'>
            <div className="mb-8 space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle2 className="text-[#1c9e86] mr-3 mt-[3px] flex-shrink-0" size={20} />
                  <p className="text-gray-700">{benefit}</p>
                </div>
              ))}
            </div>
            </div>
            

            {/* CTA with arrow */}
            <div className="flex justify-center md:justify-start">
              <a href={signupLink}>
                <button className="group hover:cursor-pointer inline-flex items-center bg-[#1c9e86] hover:bg-[#168a75] text-white font-bold py-3 px-8 rounded-lg transition duration-300 shadow-lg">
                  Start Saving Now
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
                </button>
              </a>
            </div>
            <div className="flex flex-col lg:flex-row items-center justify-center mt-10 gap-y-5 lg:gap-x-20">
              <img
                src={RBI}
                className="w-40 lg:w-40"
                alt="RBI logo"
                loading="eager"
                decoding="async"
                fetchPriority={"high"}
              />
          <span className="flex text-nowrap flex-col lg:flex-row items-center justify-center mt-2 lg:mt-0">
            Powered By:
            <img
              src={Poweredby}
              className="w-90 lg:w-250"
              alt="Powered by logo"
              loading="eager"
            />
          </span>
        </div>
          </div>

          {/* Right side - Currency Calculator */}
          <div className="w-full pb-15 md:w-1/2 lg:pl-35 flex-shrink-0 order-first lg:order-last relative max-w-full ">
            <CurrencyCalculator />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
